import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PageHeader({
  title,
  description,
  compact = false
}) {
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: '1000',
    paddingBlockEnd: compact ? '0' : '1000',
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h1",
      typography: "heading-600",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-100",
      children: description
    })]
  });
}